export const inspectionReports = {
  heading: "Inspection Reports",

  editor: {
    heading: "Editor",
    tablesCreate: "Create table",
    tablesView: "Table view",
    formatting: {
      heading: "Formatting",
      warning1: "Text style not changing",
      warning1Text: `In some cases the style of text won't change if you select bold or changing it to a heading.
      In the bottom left corner of the editor you can see what the element you have selected is. i.e. <b>h1</b>, <b>h2</b>, <b>p</b>.
      <b>h1</b>, <b>h2</b> etc. is for headings and <b>p</b> is for meant general text.

      To fix this, highlight the affected text and select the clear formatting option.  This will remove any formatting that was applied to the text and let you apply the styling you want.`,
    },
    tables: {
      heading: "Tables",
      properties: {
        heading: "Table properties",
        note1: `You can adjust properties for the table, row or a cell`,
        tableProps: "Table properties",
        rowProps: "Row proeperties",
        cellProps: "Cell properties",
      },
      borders: {
        warning1: "Border visibility",
        warning1Text: `Border styling only applies to the outer border of the selected properties,
      so table properties will change the outer border, row properties will adjust the border around the row
      and cell properties the border around each cell.

      If you want to adjust the border style for the entire table, you need use the cell properties.
      You can select multiple cells and then open the cell properties to change styling.
      
      You can select multiple cells by clicking and holding in a cell and dragging to other cells.`,
      },
      cellFormatting: {
        heading: "Formatting empty cells",
        step1:
          "Select the cells you want to change the formatting on.  You will now the cell is selected when it is highlighted, or the quick access bar for text has popped up. You can double/tripple click with the mouse to sellect a cell or hold <<SHIFT>> and use the arrow keys to select all the cells you want.",
        warning1: "Warning",
        warning1Text:
          "If the table quick access menu is visible, changing formatting will not work.",
        step2:
          "When the cell or cells are selected you can change formatting as you see fit, eg. font, font size, bold, italics, etc. and it will remember that for later.",
      },
    },
  },
};
